//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
      data(){
        return {
          dialogVisible:false,
          zbList:[], //中标人列表
          length:0,
          contactNumber:'', //联系电话
          phone:'',
          zhuangz:'',
          leixz:0,
          amobile:'',
          phoneVisible:false,
          row:'',
          zhz:'',
          info:''
        }
      },
      mounted() {
        this.projectDetail()
      },
      methods:{
        //项目详情
        projectDetail(){
          this.$get('/tra/project/detail?id='+this.$route.query.id,function(res) {
            if(res.code==200){
              this.info =res.data;
              this.contactNumber = res.data.contactNumber; //发包商电话
              for(var i=0;i<res.data.zbBidList.length;i++){
                if(getSession('user').id==res.data.zbBidList[i].userId){
                  this.amobile = res.data.zbBidList[i].contactNumber  //服务商电话
                }
              }
            }
          })
        },
        //服务商弹窗
        openVisible(){
          this.dialogVisible = true
          this.zbInfo()
        },

        // 中标人列表
        zbInfo(){
          this.$get('/tra/project/bid/zbList?projectId='+this.$route.query.id, function(res){
            if (res.code == 200) {
              this.zbList= res.data;
              this.length = res.data.length;
            }
          })
        },

        // 拨打虚拟电话
        callPhone(row){
            if(!this.contactNumber){
              this.$message.error('当前联系方式存在问题');
              return
            }
            if(!row.contactNumber){
              this.$message.error('对方联系方式存在问题');
              return
            }
            if(this.contactNumber==row.contactNumber){
              this.$message.error('双方手机号相同,暂不可用');
              return
            }
            this.phoneVisible= true;
            this.row=row;
            this.leixz=2;
            if(this.contactNumber&&row.contactNumber){
              this.checkBind(this.contactNumber,row.contactNumber)
            }
        },

        // 查询虚拟电话绑定状态
      checkBind(amobile,bmobile){
        var params ={
          aMobile:amobile,
          bMobile:bmobile
        }
        this.$get('/sys/user/call/bind',params,function(res){
          if(res.code==200){
             if(res.data.secretNo){
              this.phone= res.data.secretNo;
              this.zhuangz=1;
            }else{
              this.zhuangz=0;
            }
          }
        })
      },

      // 确定电话
      enurePhone(){
        if(this.leixz==1){  //服务商联系发包商
          if(!this.contactNumber){
            this.$message.error('当前联系方式存在错误!');
            return
          }
          if(!this.info.contactNumber){
            this.$message.error('对方联系方式存在错误!');
            return
          }
          this.$post('/sys/user/call/bind', {
            amobile:this.contactNumber,
            bmobile:this.info.contactNumber,
            buserId:this.info.createBy,
            traProjectId:this.$route.query.id
          }, function(res){
            if (res.code == 200) {
              if(res.data.secretNo){
                this.zhuangz=1;
                this.phone= res.data.secretNo;
              }else{
                this.zhz=1;
              }
            }
          },true)
        }
        if(this.leixz==2){   //发包商联系服务商
          if(!this.contactNumber){
            this.$message.error('当前联系方式存在错误!');
            return
          }
          if(!this.row.contactNumber){
            this.$message.error('对方联系方式存在错误!');
            return
          }
          this.$post('/sys/user/call/bind', {
            amobile:this.contactNumber,
            bmobile:this.row.contactNumber,
            buserId:this.row.userId,
            traProjectId:this.$route.query.id
          }, function(res){
            if (res.code == 200) {
              if(res.data.secretNo){
                this.zhuangz=1;
                this.phone= res.data.secretNo;
              }else{
                 this.zhz=1;
              }
            }
          },true)
        }
      },

      // 服务商联系发包商
      linkOut(leixz){
        this.leixz=leixz;
        this.contactNumber = this.amobile;
        if(!this.contactNumber){
          this.$message.error('当前联系方式存在问题');
          return
        }
        if(!this.info.contactNumber){
          this.$message.error('对方联系方式存在问题');
          return
        }
        if(this.contactNumber&&this.info.contactNumber){
          this.phoneVisible= true;
          this.checkBind(this.contactNumber,this.info.contactNumber)
        }
      },

      // 拨打电话
      callTel(phone){
        const a = document.createElement("a");
        a.href = "tel:"+phone+""
        a.click();
      },

      }

    }
